export default __webpack_public_path__ + "static/media/hamburger.1280d20e.svg";